var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryTranslations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 13.3333L16.6663 21.6666M6.66634 23.3333L16.6663 13.3333L19.9997 8.33325M3.33301 8.33325H23.333M11.6663 3.33325H13.333M21.5214 28.3333H33.4779M21.5214 28.3333L18.333 34.9999M21.5214 28.3333L26.2968 18.3483C26.6816 17.5437 26.874 17.1414 27.1373 17.0143C27.3662 16.9037 27.6331 16.9037 27.8621 17.0143C28.1253 17.1414 28.3177 17.5437 28.7025 18.3483L33.4779 28.3333M33.4779 28.3333L36.6663 34.9999",
    stroke: "#6374A6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryTranslations);
export default __webpack_public_path__ + "react/media/category-translations.ac178115c9cb06fb1c81ce10c0c35092.svg";
export { ForwardRef as ReactComponent };